import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, Route, Router } from "@angular/router";
import { LayoutComponent } from "app/layout/layout.component";
import { AuthGuard } from "./core/auth/guards/auth.guard";
import { NoAccessComponent } from "app/modules/access/no-access/no-access.component";

function fokusPerformanceMonitorRedirect(route: ActivatedRouteSnapshot) {
  const router = inject(Router);
  const qs = new URLSearchParams(
    route.queryParams as Record<string, string>,
  ).toString();
  return router.parseUrl(
    `/monitoring/performance-monitor${qs ? `?${qs}` : ""}`,
  );
}

export const appRoutes: Route[] = [
  { path: "", pathMatch: "full", redirectTo: "system-management" },
  { path: "no-access", component: NoAccessComponent },

  {
    path: "batterypass",
    component: LayoutComponent,
    data: { layout: "dense" },
    children: [
      {
        path: "",
        loadComponent: () =>
          import("app/modules/battery-pass/battery-pass.component").then(
            (module) => module.BatteryPassComponent,
          ),
      },
      {
        path: ":battpassid_sha256",
        loadComponent: () =>
          import("app/modules/battery-pass/battery-pass.component").then(
            (module) => module.BatteryPassComponent,
          ),
      },
    ],
  },

  {
    path: "",
    redirectTo: "system-management",
    pathMatch: "full",
  },
  {
    path: "",
    canActivate: [AuthGuard],
    canActivateChild: [],
    component: LayoutComponent,
    children: [
      {
        path: "monitoring",
        loadChildren: () =>
          import("app/modules/installer/modules/monitoring/monitoring.routes"),
      },
      {
        path: "operation",
        loadChildren: () =>
          import("app/modules/installer/modules/operation/operation.routes"),
      },
      /*
      {
        path: "fokus",
        children: [
          {
            path: "plant-status",
            pathMatch: "full",
            redirectTo: "/monitoring/plant-status",
          },
          {
            path: "performance-monitor",
            canActivate: [fokusPerformanceMonitorRedirect],
            // Guard always redirects; component never renders.
            component: NoAccessComponent,
          },
          {
            path: "notification-protocol",
            pathMatch: "full",
            redirectTo: "/operation/notification-protocol",
          },
        ],
      },*/
      {
        path: "system-management",
        children: [
          {
            path: "",
            loadChildren: () =>
              import("app/modules/system-management/system-management.routes"),
          },
        ],
      },
      {
        path: "accountsettings",
        loadChildren: () =>
          import("app/modules/installer/modules/settings/account-settings/accountsettings.routes"),
      },
      /*
      {
        path: "settings",
        children: [
          {
            path: "accountsettings",
            loadChildren: () =>
              import("app/modules/installer/modules/settings/account-settings/accountsettings.routes"),
          },
          {
            path: "portalsettings",
            loadChildren: () =>
              import("app/modules/installer/modules/settings/portal-settings/portalsettings.routes"),
          },
        ],
      },*/
      {
        path: "portal-settings",
        children: [
          {
            path: "",
            loadChildren: () =>
              import("app/modules/installer/modules/settings/portal-settings/portalsettings.routes"),
          },
        ],
      },
      {
        path: "information",
        children: [
          {
            path: "support",
            loadChildren: () =>
              import("app/modules/installer/modules/information/support/support.routes"),
          },
          {
            path: "documents",
            loadChildren: () =>
              import("app/modules/installer/modules/information/documents/documents.routes"),
          },
          {
            path: "reports",
            loadChildren: () =>
              import("app/modules/installer/modules/information/reports/reports.routes"),
          },
        ],
      },
    ],
  },
  {
    path: "subscription",
    children: [
      {
        path: "",
        loadChildren: () =>
          import("app/modules/subscription/subscription.routes"),
      },
    ],
  },
  // Fallback for outdated/deprecated URLs.
  { path: "**", redirectTo: "system-management" },
];
